import * as React from 'react';
import { assertNever, IncidentType } from '../../amorg-common';
import { ProtectedPageContext } from '../../pages/_contexts/ProtectedPageContext';
import { Icon, iconName } from '../icons/Icons';


type IncideptIconProps = {
    type:IncidentType
}
export const IncidentIcon = ({ type }: IncideptIconProps): JSX.Element => {

    const ctx = React.useContext(ProtectedPageContext);

    let icon:iconName = 'status_error';
    let color:string = ctx.colors.icon.default;
    switch (type)
    {
        case 'issue': 
            icon = 'warning'; 
            color = ctx.colors.icon.default;
            break;
        case 'almost-accident': 
            icon = 'falling'; 
            color = ctx.colors.icon.default;
            break;
        case 'work-injury': 
            icon = 'personal_injury'; 
            color = ctx.colors.icon.default;
            break;
        case 'whistleblower': 
            icon = 'record_voice_over'; 
            color = ctx.colors.icon.white;
            break;
        default: assertNever(type);
    }


    return (
        <Icon name={icon} size='medium' color={color} />
    );
} 